import { roles } from "../roles";

type IO = string | undefined;

export const getRoleTitleByIdentifier = (identifier: IO): IO => {
  return roles.find((role) => role.identifier === identifier)?.title;
};
